import React from 'react';
import Header from '../components/Header';
import PricingPlans from '../components/pricing/PricingPlans';
import { useAuth } from '../contexts/AuthContext';

export default function Pricing() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Choose Your Plan</h1>
          <p className="text-xl text-gray-600">Get started with InterviewAdvantage today</p>
        </div>
        <PricingPlans user={user} />
      </div>
    </div>
  );
}